module.exports = __webpack_public_path__ + "static/Commissioner-Regular-ef5c199c7beed560ccc8f4e6c21e7764.ttf";